// import React, { useState, useEffect } from "react";
// import {
//   Search,
//   ChevronDown,
//   ChevronUp,
//   Pencil,
//   Trash2,
//   PlusCircle,
//   ChevronLeft,
//   ChevronRight,
//   HelpCircle,
// } from "lucide-react";
// import AddFaqModal from "./AddFaqModal";

// const AdminFAQList = () => {
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [entriesPerPage, setEntriesPerPage] = useState(10);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [expanded, setExpanded] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [faq, setFaqs] = useState([]);

//   // Sample FAQ data
//   const faqs = [
//     {
//       id: 1,
//       question: "How can I track my order?",
//       answer:
//         "Once your order is shipped, you’ll receive a tracking link via email and SMS. You can also check the status in your “My Orders” section.",
//     },
//     {
//       id: 2,
//       question: "What is your return policy?",
//       answer:
//         "We offer a 7-day easy return policy. Items must be unused and in their original packaging.",
//     },
//     {
//       id: 3,
//       question: "Do you offer international shipping?",
//       answer:
//         "Currently, we only ship within India. International shipping is coming soon!",
//     },
//     {
//       id: 4,
//       question: "Can I cancel my order?",
//       answer:
//         "Orders can be cancelled within 12 hours of placement, as long as they haven’t been shipped yet.",
//     },
//     {
//       id: 5,
//       question: "How can I contact customer support?",
//       answer:
//         "You can reach us via our “Contact Us” page, or email support@yourshop.com. We respond within 24 hours.",
//     },
//   ];

//   useEffect(() => {
//     const timer = setTimeout(() => setLoading(false), 1500);
//     return () => clearTimeout(timer);
//   }, []);

//   const handleSaveFaq = (newFaq) => {
//     setFaqs([...faq, newFaq]);
//   };

//   // Filtering and pagination
//   const filteredFaqs = faqs.filter((f) =>
//     f.question.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   const totalPages = Math.ceil(filteredFaqs.length / entriesPerPage);
//   const startIndex = (currentPage - 1) * entriesPerPage;
//   const endIndex = startIndex + entriesPerPage;
//   const currentFaqs = filteredFaqs.slice(startIndex, endIndex);

//   const SkeletonRow = () => (
//     <tr className="border-b border-gray-100">
//       {[...Array(3)].map((_, i) => (
//         <td key={i} className="px-4 py-4">
//           <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
//         </td>
//       ))}
//     </tr>
//   );

//   return (
//     <div className="min-h-screen">
//       <div className="w-full mx-auto">
//         {/* Header */}
//         <div className="flex justify-between items-center mb-6">
//           <h1 className="text-xl md:text-3xl font-philosopher text-primaryTextColor flex items-center gap-2">
//             <HelpCircle className="w-7 h-7 text-primaryColor" />
//             FAQ Management
//           </h1>
//         </div>

//         {/* Tip Card */}
//         {/* <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6 flex items-start gap-3">
//           <span className="text-2xl">💡</span>
//           <p className="text-sm text-gray-700">
//             <strong>Tip:</strong> You can manage, edit, or delete frequently
//             asked questions here.
//           </p>
//         </div> */}

//         {/* Filters and Search */}
//         <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
//           <div className="flex justify-between items-center gap-4">
//             <div className="flex items-center gap-4">
//               {/* <div className="flex items-center gap-2">
//                                 <span className="text-sm text-gray-600">Show</span>
//                                 <select
//                                     value={entriesPerPage}
//                                     onChange={(e) => {
//                                         setEntriesPerPage(Number(e.target.value));
//                                         setCurrentPage(1);
//                                     }}
//                                     className="border border-gray-300 rounded px-3 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
//                                 >
//                                     <option value={5}>5</option>
//                                     <option value={10}>10</option>
//                                     <option value={20}>20</option>
//                                 </select>
//                                 <span className="text-sm text-gray-600">entries</span>
//                             </div> */}

//               <div className="relative">
//                 <input
//                   type="text"
//                   placeholder="Search FAQs..."
//                   value={searchTerm}
//                   onChange={(e) => {
//                     setSearchTerm(e.target.value);
//                     setCurrentPage(1);
//                   }}
//                   className="border border-gray-300 rounded-lg pl-4 pr-10 py-2 w-full md:w-96 focus:outline-none focus:ring-1 focus:ring-primaryColor"
//                 />
//                 <Search className="absolute right-3 top-2.5 w-5 h-5 text-gray-400" />
//               </div>
//             </div>
//             <button
//               onClick={() => setIsModalOpen(true)}
//               className="bg-white border-2 border-blue-500 text-blue-500 px-6 py-2 rounded-lg flex items-center gap-2 hover:bg-blue-50 transition"
//             >
//               <PlusCircle className="w-5 h-5" />
//               Add New FAQ
//             </button>
//           </div>
//         </div>

//         {/* Table */}
//         <div className="bg-white rounded-lg shadow-sm overflow-hidden">
//           <div className="overflow-x-auto">
//             <table className="w-full">
//               <thead className="bg-gray-50 border-b border-gray-200">
//                 <tr>
//                   <th className="px-4 py-4 text-left text-sm font-semibold text-gray-700">#</th>
//                   <th className="px-4 py-4 text-left text-sm font-semibold text-gray-700">
//                     Question
//                   </th>
//                   <th className="px-4 py-4 text-left text-sm font-semibold text-gray-700">
//                     Answer
//                   </th>
//                   <th className="px-4 py-4 text-left text-sm font-semibold text-gray-700">
//                     Actions
//                   </th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {loading ? (
//                   // ✅ Skeleton Loader - consistent with other admin tables
//                   [...Array(5)].map((_, i) => (
//                     <tr key={i} className="border-b border-gray-100">
//                       <td className="px-4 py-4">
//                         <div className="h-4 w-6 bg-gray-200 rounded animate-pulse"></div>
//                       </td>
//                       <td className="px-4 py-4">
//                         <div className="h-4 w-60 bg-gray-200 rounded animate-pulse"></div>
//                       </td>
//                       <td className="px-4 py-4">
//                         <div className="h-4 w-80 bg-gray-200 rounded animate-pulse"></div>
//                       </td>
//                       <td className="px-4 py-4">
//                         <div className="h-4 w-20 bg-gray-200 rounded animate-pulse"></div>
//                       </td>
//                     </tr>
//                   ))
//                 ) : currentFaqs.length > 0 ? (
//                   currentFaqs.map((faq, index) => (
//                     <React.Fragment key={faq.id}>
//                       <tr
//                         className="border-b border-gray-100 hover:bg-gray-50 transition cursor-pointer"
//                         onClick={() => setExpanded(expanded === faq.id ? null : faq.id)}
//                       >
//                         {/* Serial number */}
//                         <td className="px-4 py-4 text-gray-500 font-medium">
//                           {(currentPage - 1) * entriesPerPage + index + 1}
//                         </td>

//                         {/* Question */}
//                         <td className="px-4 py-4 text-sm font-medium text-gray-900 flex items-center gap-2">
//                           {faq.question}
//                           {expanded === faq.id ? (
//                             <ChevronUp className="w-4 h-4 text-gray-500" />
//                           ) : (
//                             <ChevronDown className="w-4 h-4 text-gray-500" />
//                           )}
//                         </td>

//                         {/* Truncated Answer */}
//                         <td className="px-4 py-4 text-sm text-gray-700 truncate max-w-xs">
//                           {faq.answer.length > 50
//                             ? faq.answer.slice(0, 50) + "..."
//                             : faq.answer}
//                         </td>

//                         {/* Actions */}
//                         <td className="px-4 py-4">
//                           <div className="flex items-center gap-2">
//                             <button
//                               className="p-2 hover:bg-blue-50 rounded-lg transition"
//                               title="Edit FAQ"
//                             >
//                               <Pencil className="w-4 h-4 text-[#6278e8]" />
//                             </button>
//                             <button
//                               className="p-2 hover:bg-red-50 rounded-lg transition"
//                               title="Delete FAQ"
//                             >
//                               <Trash2 className="w-4 h-4 text-red-500" />
//                             </button>
//                           </div>
//                         </td>
//                       </tr>

//                       {/* Expanded Answer Row */}
//                       {expanded === faq.id && (
//                         <tr className="bg-gray-50 border-b border-gray-200">
//                           <td colSpan={4} className="px-6 py-4 text-sm text-gray-700">
//                             {faq.answer}
//                           </td>
//                         </tr>
//                       )}
//                     </React.Fragment>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan={4} className="px-4 py-8 text-center text-gray-500">
//                       No FAQs found
//                     </td>
//                   </tr>
//                 )}
//               </tbody>


//             </table>
//           </div>

//           {/* Pagination */}
//           {!loading && filteredFaqs.length > 0 && (
//             <div className="px-6 py-4 border-t border-gray-200 flex items-center justify-between">
//               <div className="text-sm text-gray-600">
//                 Showing {startIndex + 1} to{" "}
//                 {Math.min(endIndex, filteredFaqs.length)} of{" "}
//                 {filteredFaqs.length} FAQs
//               </div>

//               <div className="flex items-center gap-2">
//                 <button
//                   onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
//                   disabled={currentPage === 1}
//                   className="p-2 rounded-lg border border-gray-300 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition"
//                 >
//                   <ChevronLeft className="w-5 h-5" />
//                 </button>

//                 {[...Array(totalPages)].map((_, i) => (
//                   <button
//                     key={i}
//                     onClick={() => setCurrentPage(i + 1)}
//                     className={`px-4 py-2 rounded-lg transition ${currentPage === i + 1
//                       ? "bg-blue-500 text-white"
//                       : "border border-gray-300 hover:bg-gray-50"
//                       }`}
//                   >
//                     {i + 1}
//                   </button>
//                 ))}

//                 <button
//                   onClick={() =>
//                     setCurrentPage((p) => Math.min(totalPages, p + 1))
//                   }
//                   disabled={currentPage === totalPages}
//                   className="p-2 rounded-lg border border-gray-300 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition"
//                 >
//                   <ChevronRight className="w-5 h-5" />
//                 </button>
//               </div>
//             </div>
//           )}
//         </div>
//       </div>
//       <AddFaqModal
//         isOpen={isModalOpen}
//         onClose={() => setIsModalOpen(false)}
//         onSave={handleSaveFaq}
//       />
//     </div>
//   );
// };

// export default AdminFAQList;


import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-hot-toast";
import {
  Search,
  ChevronDown,
  ChevronUp,
  Pencil,
  Trash2,
  PlusCircle,
  ChevronLeft,
  ChevronRight,
  HelpCircle,
} from "lucide-react";
import AddFaqModal from "./AddFaqModal";
import DeleteAlertModal from "../../../components/common/DeleteAlertModal";
const AdminFAQList = () => {
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [expanded, setExpanded] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedFaq, setSelectedFaq] = useState(null);
  const [faqs, setFaqs] = useState([]);

  // Delete modal states
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [faqToDelete, setFaqToDelete] = useState(null);
  const [dltLoading, setDltLoading] = useState(false);

  // Fetch all FAQs
  const fetchFaqs = async () => {
    try {
      setLoading(true);
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/faqs/get-all-faqs`
      );
      if (res.data.success) {
        setFaqs(res.data.data);
      } else {
        toast.error("Failed to fetch FAQs");
      }
    } catch (err) {
      console.error("Error fetching FAQs:", err);
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFaqs();
  }, []);

  // Add/Edit FAQ
  const handleSaveFaq = async (faqData, isEdit = false, id = null) => {
    try {
      const url = isEdit
        ? `${process.env.REACT_APP_API_URL}/faqs/update-faq/${id}`
        : `${process.env.REACT_APP_API_URL}/faqs/create-faq`;
      const method = isEdit ? "patch" : "post";

      await axios[method](url, faqData);

      toast.success(isEdit ? "FAQ updated successfully" : "FAQ added successfully");
      setIsModalOpen(false);
      setSelectedFaq(null);
      fetchFaqs();
    } catch (err) {
      console.error("Error saving FAQ:", err);
      toast.error("Failed to save FAQ");
    }
  };

  // Delete FAQ with custom modal
  const handleConfirmDelete = async () => {
    if (!faqToDelete) return;
    setDltLoading(true);
    try {
      await axios.delete(
        `${process.env.REACT_APP_API_URL}/faqs/delete-faq/${faqToDelete._id}`
      );
      toast.success("FAQ deleted successfully");
      fetchFaqs();
    } catch (err) {
      console.error("Error deleting FAQ:", err);
      toast.error("Failed to delete FAQ");
    } finally {
      setDltLoading(false);
      setIsDeleteOpen(false);
      setFaqToDelete(null);
    }
  };

  // Filtering and pagination
  const filteredFaqs = faqs.filter((f) =>
    f.question.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const totalPages = Math.ceil(filteredFaqs.length / entriesPerPage);
  const startIndex = (currentPage - 1) * entriesPerPage;
  const endIndex = startIndex + entriesPerPage;
  const currentFaqs = filteredFaqs.slice(startIndex, endIndex);

  return (
    <div className="min-h-screen">
      <div className="w-full mx-auto">
        {/* Header */}
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-xl md:text-3xl font-philosopher text-primaryTextColor flex items-center gap-2">
            <HelpCircle className="w-7 h-7 text-primaryColor" />
            FAQ Management
          </h1>
          {/* <button
            onClick={() => {
              setSelectedFaq(null);
              setIsModalOpen(true);
            }}
            className="bg-white border-2 border-blue-500 text-blue-500 px-6 py-2 rounded-lg flex items-center gap-2 hover:bg-blue-50 transition"
          >
            <PlusCircle className="w-5 h-5" />
            Add New FAQ
          </button> */}
        </div>

        {/* Search Bar */}
        <div className="bg-white rounded-lg shadow-sm p-6 mb-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="relative">
            <input
              type="text"
              placeholder="Search FAQs..."
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setCurrentPage(1);
              }}
              className="border border-gray-300 rounded-lg pl-4 pr-10 py-2 w-full md:w-96 focus:outline-none focus:ring-1 focus:ring-primaryColor"
            />
            <Search className="absolute right-3 top-2.5 w-5 h-5 text-gray-400" />
          </div>
          <div>
            <button
              onClick={() => {
                setSelectedFaq(null);
                setIsModalOpen(true);
              }}
              className="bg-white border-2 border-blue-500 text-blue-500 px-6 py-2 rounded-lg flex items-center gap-2 hover:bg-blue-50 transition"
            >
              <PlusCircle className="w-5 h-5" />
              Add New FAQ
            </button>
          </div>
        </div>

        {/* Table */}
        <div className="bg-white rounded-lg shadow-sm overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50 border-b border-gray-200">
                <tr>
                  <th className="px-4 py-4 text-left text-sm font-semibold text-gray-700">#</th>
                  <th className="px-4 py-4 text-left text-sm font-semibold text-gray-700">Question</th>
                  <th className="px-4 py-4 text-left text-sm font-semibold text-gray-700">Answer</th>
                  <th className="px-4 py-4 text-left text-sm font-semibold text-gray-700">Actions</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  [...Array(5)].map((_, i) => (
                    <tr key={i} className="border-b border-gray-100">
                      {[...Array(4)].map((_, j) => (
                        <td key={j} className="px-4 py-4">
                          <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
                        </td>
                      ))}
                    </tr>
                  ))
                ) : currentFaqs.length > 0 ? (
                  currentFaqs.map((faq, index) => (
                    <React.Fragment key={faq._id}>
                      <tr
                        className="border-b border-gray-100 hover:bg-gray-50 transition cursor-pointer"
                        onClick={() =>
                          setExpanded(expanded === faq._id ? null : faq._id)
                        }
                      >
                        <td className="px-4 py-4 text-gray-500 font-medium">
                          {(currentPage - 1) * entriesPerPage + index + 1}
                        </td>
                        <td className="px-4 py-4 text-sm font-medium text-gray-900 flex items-center gap-2">
                          {faq.question}
                          {expanded === faq._id ? (
                            <ChevronUp className="w-4 h-4 text-gray-500" />
                          ) : (
                            <ChevronDown className="w-4 h-4 text-gray-500" />
                          )}
                        </td>
                        <td className="px-4 py-4 text-sm text-gray-700 truncate max-w-xs">
                          {faq.answer.length > 50
                            ? faq.answer.slice(0, 50) + "..."
                            : faq.answer}
                        </td>
                        <td className="px-4 py-4">
                          <div className="flex items-center gap-2">
                            <button
                              className="p-2 hover:bg-blue-50 rounded-lg transition"
                              title="Edit FAQ"
                              onClick={(e) => {
                                e.stopPropagation();
                                setSelectedFaq(faq);
                                setIsModalOpen(true);
                              }}
                            >
                              <Pencil className="w-4 h-4 text-[#6278e8]" />
                            </button>
                            <button
                              className="p-2 hover:bg-red-50 rounded-lg transition"
                              title="Delete FAQ"
                              onClick={(e) => {
                                e.stopPropagation();
                                setFaqToDelete(faq);
                                setIsDeleteOpen(true);
                              }}
                            >
                              <Trash2 className="w-4 h-4 text-red-500" />
                            </button>
                          </div>
                        </td>
                      </tr>
                      {expanded === faq._id && (
                        <tr className="bg-gray-50 border-b border-gray-200">
                          <td colSpan={4} className="px-6 py-4 text-sm text-gray-700">
                            {faq.answer}
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))
                ) : (
                  <tr>
                    <td colSpan={4} className="px-4 py-8 text-center text-gray-500">
                      No FAQs found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {!loading && filteredFaqs.length > 0 && (
            <div className="px-6 py-4 border-t border-gray-200 flex items-center justify-between">
              <div className="text-sm text-gray-600">
                Showing {startIndex + 1} to{" "}
                {Math.min(endIndex, filteredFaqs.length)} of{" "}
                {filteredFaqs.length} FAQs
              </div>
              <div className="flex items-center gap-2">
                <button
                  onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
                  disabled={currentPage === 1}
                  className="p-2 rounded-lg border border-gray-300 hover:bg-gray-50 disabled:opacity-50"
                >
                  <ChevronLeft className="w-5 h-5" />
                </button>
                {[...Array(totalPages)].map((_, i) => (
                  <button
                    key={i}
                    onClick={() => setCurrentPage(i + 1)}
                    className={`px-4 py-2 rounded-lg transition ${currentPage === i + 1
                        ? "bg-blue-500 text-white"
                        : "border border-gray-300 hover:bg-gray-50"
                      }`}
                  >
                    {i + 1}
                  </button>
                ))}
                <button
                  onClick={() =>
                    setCurrentPage((p) => Math.min(totalPages, p + 1))
                  }
                  disabled={currentPage === totalPages}
                  className="p-2 rounded-lg border border-gray-300 hover:bg-gray-50 disabled:opacity-50"
                >
                  <ChevronRight className="w-5 h-5" />
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Add/Edit Modal */}
      <AddFaqModal
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
          setSelectedFaq(null);
        }}
        onSave={handleSaveFaq}
        faqData={selectedFaq}
      />

      {/* Delete Confirmation Modal */}
      <DeleteAlertModal
        isOpen={isDeleteOpen}
        onClose={() => setIsDeleteOpen(false)}
        dltType="FAQ"
        dltName={faqToDelete?.question}
        onConfirm={handleConfirmDelete}
        dltLoading={dltLoading}
      />
    </div>
  );
};

export default AdminFAQList;

